import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

// GET DETALLES DE REQUISA FILTRADORS POR FECHA
export const getRequisasDetalle = async (data) => {
    return await PrivateInterceptor('Compras/Purchases/Details/listadoRequisasPorFecha', 'POST', data);
}

// GET DETALLES DE UNA REQUISA 
export const getDetalleRequisa = async (PurchaseRequest) => {
    const result = await PrivateInterceptor(`PurchaseRequestDetails/getDetalleRequisa`, 'POST', { PurchaseRequest })
    return result;
}

// ASIGNAR A UN AGENTE DE COMPRAS
export const assignAgent = async (body) => {
    const respuesta = await PrivateInterceptor('Compras/Purchases/ChangeAgent', 'PUT', body);
    return respuesta;
}

export const guardarDetallesRequisas = async (data) => {
    const respuesta = await PrivateInterceptor('PurchaseRequestDetails', 'POST', data);
    return respuesta;
}

// OBTENER DETALLES DE REQUISAS PENDIENTE DE AUTORIZAR
export const getRequisasDetallePendienteAutorizar = async (data) => {
    return await PrivateInterceptor('Compras/Purchases/Details/Autorizar', 'GET', data);
}

export const putPermiso4 = async (IdPurcharesRequestDetail, Permiso4, FechaPermiso4, UsuarioPermiso4, IdEstado) => {
    const respuesta = await PrivateInterceptor('PurchaseRequestDetails/autorizarRequisa/permiso4', 'PUT', {
        IdPurcharesRequestDetail,
        Permiso4,
        FechaPermiso4,
        UsuarioPermiso4,
        IdEstado
    });
    return respuesta;
}

// GET REQUISAS PENDIENTES DE APROBAR PLANT MANAGER
export const getRequisasPendientesAprobarPlantManager = async () => {
    return await PrivateInterceptor('PurchaseRequestDetails/ListaPlantManagerPD', 'POST');
}

// GET REQUISAS PENDIENTES DE APROBAR FINANZAS
export const getRequisasPendientesAprobarFinanzas = async () => {
    return await PrivateInterceptor('PurchaseRequestDetails/ListaFinancePD', 'POST');
}

// APROBAR DETALLE DE REQUISA PERMISO 1
export const putPermiso1 = async (IdPurcharesRequestDetail, Permiso1, FechaPermiso1, UsuarioPermiso1, IdEstado) => {
    const respuesta = await PrivateInterceptor('PurchaseRequestDetails/autorizarRequisa/permiso1', 'PUT', {
        IdPurcharesRequestDetail,
        Permiso1,
        FechaPermiso1,
        IdEstado
    });
    return respuesta;
}

// APROBAR DETALLE DE REQUISA PERMISO 3
export const putPermiso3 = async (IdPurcharesRequestDetail, Permiso3, FechaPermiso3, UsuarioPermiso3, IdEstado) => {
    const respuesta = await PrivateInterceptor('PurchaseRequestDetails/autorizarRequisa/permiso3', 'PUT', {
        IdPurcharesRequestDetail,
        Permiso3,
        FechaPermiso3,
        IdEstado
    });
    return respuesta;
}

export const putEstadoDetalle = async (data) => {
    const respuesta = await PrivateInterceptor('estadoRequisas/actualizarEstadoDetalle', 'PUT', data);
    return respuesta;
}

// LISTADO REQUISAS AUTORIZAR BODEGA
export const getListaRequisasAutorizarBodega = (dates) => {
    const respuesta = PrivateInterceptor('PurchaseRequestDetails/autorizarRequisaBodega', 'POST', dates);
    return respuesta;
}

// CAMBIAR ESTADO BODEGA SUMINISTRO 
export const changePermisoPurchaseRequestDetailBodega = (data) => {
    const respuesta = PrivateInterceptor('PurchaseRequestDetails/changePermisoPurchaseRequestDetailBodega', 'POST', data);
    return respuesta
}

// OBTIENER LISTADO DETALLE AUTORIZADO
export const ListadoOrdenesCompraAuth = async () => {
    const result = await PrivateInterceptor('PurchaseRequestDetails/ListadoOrdenesCompraAuth', 'GET')
    return result;
}

// OBTIENER DETALLE DE UNA REQUISA
export const getPurchaseRequestDetailAuth = async (IdPurchaseRequest) => {
    const result = await PrivateInterceptor('PurchaseRequestDetails/ListadoOrdenesCompraAuthPurchaseRequest', 'POST', { IdPurchaseRequest })
    return result;
}